import {connect} from 'react-redux';
import EntitybanksaccountTable from './EntitybanksaccountTable';
import {
  requestEntityList,
  fetchEntitybanksListNotDeleted,
  entitybanksListIsDirty,
  editEntitybanks,
  selectEntitybanksUi
} from '../../redux/actions/entitybanksaccount';

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    entity_banks_account: state.entity_banks_account
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestEntityList: () => {
      dispatch(requestEntityList());
    },
    fetchEntitybanksListNotDeleted: () => {
      dispatch(fetchEntitybanksListNotDeleted());
    },
    entitybanksListIsDirty: value => {
      dispatch(entitybanksListIsDirty(value));
    },
    editEntitybanks: id => {
      dispatch(editEntitybanks(id));
    },
    selectEntitybanksUi: value => {
      dispatch(selectEntitybanksUi(value));
    }

    // fetchStaffList: () => {
    //   dispatch(fetchStaffListNotDeleted())
    // },
    // loadStaffMemberDetails: (aws_cognito_id) => {
    //   // console.log(data)
    //   dispatch(loadStaffMemberDetails(aws_cognito_id))
    // }
  };
};

const EntitybanksaccountTableContainer = connect(mapStateToProps, mapDispatchToProps)(EntitybanksaccountTable);

export default EntitybanksaccountTableContainer;
